import header from '../modules/header/index';
import basketResult from "../modules/basketResult";
import initSlideShow from '../modules/initSlideShow';
import relatedProducts from '../modules/productCarousel';
import initAnimations from '../modules/initAnimation';
import addToCardEventInit from "../modules/addToCardEvent";

jQuery(function() {
    header();
    basketResult();
    initSlideShow();
    relatedProducts();
    initAnimations();
    addToCardEventInit();
})